import { c as _c } from "react/compiler-runtime";
import GridColumn from "@/components/common/grid-column/grid-column";
import GridRow from "@/components/common/grid-row/grid-row";
import SuperTitle from "@/components/common/supertitle/supertitle";
import css from "./product-points.module.scss";
import Link, { LinkType } from "@/components/common/link/link";
import { MediaContentCombo } from "@/sanity/sanity.types";
import imageUrl from "@/sanity/utilities/imageUrl";
import cssUtilities from "@/components/utilities.module.scss";
import Card, { CardStyle } from "@/components/common/card/card";
import Image from "@/components/common/image/image";
interface IProductPointsProps {
  data: MediaContentCombo;
}
const ProductPoints = props => {
  const $ = _c(28);
  const {
    data
  } = props;
  const {
    cta,
    eyebrow,
    features,
    media,
    headline
  } = data;
  let t0;
  if ($[0] !== headline || $[1] !== media) {
    t0 = media?.asset && <Image className={css.productPointsImage} src={imageUrl(media.asset).width(600).url()} alt={headline ?? ""} srcSet={`
                ${imageUrl(media.asset).width(560).url()} 560w,
                ${imageUrl(media.asset).width(600).url()} 600w
              `} sizes="(width <= 640px) 560px, 600px" />;
    $[0] = headline;
    $[1] = media;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = <GridColumn lg={6}>{t0}</GridColumn>;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== eyebrow) {
    t2 = <SuperTitle className="mt-5 lg:mt-0">{eyebrow}</SuperTitle>;
    $[5] = eyebrow;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== headline) {
    t3 = <h2>{headline}</h2>;
    $[7] = headline;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== features) {
    t4 = features?.map(_temp);
    $[9] = features;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <ul className={`${css.productPointsList} ${cssUtilities.desktopFlex}`}>{t4}</ul>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== features) {
    t6 = features?.map(_temp2);
    $[13] = features;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t5 || $[18] !== t6) {
    t7 = <GridColumn lg={6}><div className={css.productPointsContent}>{t2}{t3}{t5}{t6}</div></GridColumn>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== cta) {
    t8 = cta?.link?.href && cta?.link?.label && <Link href={cta.link.href} linkType={LinkType.BUTTON} className="!w-full lg:!mx-auto lg:!w-max" data-cta-id={cta.link?.ctaId ?? ""} data-cta-value={cta.link?.ctaValue ?? ""}>{cta.link.label}</Link>;
    $[20] = cta;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t8) {
    t9 = <GridColumn lg={12} className="mt-7 lg:mt-9">{t8}</GridColumn>;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t1 || $[25] !== t7 || $[26] !== t9) {
    t10 = <GridRow className={css.productPointsSection}>{t1}{t7}{t9}</GridRow>;
    $[24] = t1;
    $[25] = t7;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
};
export default ProductPoints;
function _temp(feature, index) {
  return <li key={index} className={css.productPointsListItem}>{feature.icon?.asset && <Image src={imageUrl(feature.icon?.asset).width(41).url()} alt={feature.title ?? ""} width={41} height={41} />}<div className={css.productPointsListItemContent}><span className={css.productPointsListItemTitle}>{feature.title}</span><p className={css.productPointsListItemDescription}>{feature.description}</p></div></li>;
}
function _temp2(feature_0, index_0) {
  return <Card className={cssUtilities.mobile} key={index_0} imgUrl={feature_0.icon?.asset ? imageUrl(feature_0.icon.asset).width(41).url() : undefined} title={feature_0.title ?? ""} description={feature_0.description ?? ""} style={CardStyle.Secondary} imgWidth={41} imgHeight={41} />;
}